import React from 'react';
import { FiAlertCircle, FiSave } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

/**
 * Barra flotante que solo aparece si hay algo que guardar. Sustituye al botón
 * suelto y al aviso tardío de "no has cambiado nada".
 */
const BarraGuardado = ({ visible, totalCambios, guardando, onDescartar }) => {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <div className="pu-barra-guardado" role="status">
      <span className="pu-barra-info">
        <FiAlertCircle />
        {totalCambios === 1 ? '1 cambio sin guardar' : `${totalCambios} cambios sin guardar`}
      </span>

      <div className="pu-barra-acciones">
        <button
          type="button"
          className="pu-btn-secundario"
          onClick={onDescartar}
          disabled={guardando}
        >
          Descartar
        </button>
        {/* El submit lo gestiona el form que la envuelve */}
        <button
          type="submit"
          className="pu-btn-primario"
          disabled={guardando}
        >
          <FiSave /> {guardando ? t('perfilUsuario.guardando') : t('perfilUsuario.guardarCambios')}
        </button>
      </div>
    </div>
  );
};

export default BarraGuardado;
